import { HistoryFullReportData } from "@entities/history";
import { ReportSection } from "../types";

export const getReportNavigation = (report: HistoryFullReportData): ReportSection[] => {
    const hasCrashes = report.accidents?.crashesHistory.length > 0;
    const isLegalClear =
        report.pledge.status === "ok" ||
        report.registration.status === "ok" ||
        report.stealing.status === "ok";
    const hasRepair = report.eventsOthersHistory.some((e) => e.type === "repairCalculation");
    const isCommercialClear = [
        ...(report.taxiData?.recaps ?? []),
        ...(report.carsharingData?.recaps ?? [])
    ].every((recap) => recap.status === "ok");
    const isPaymentsClear =
        !Array.isArray(report.insurancePayments) || report.insurancePayments.length === 0;
    const hasFines = report.hasFines;
    const hasAuction =
        Array.isArray(report.salvageCarAuctionRecords) &&
        report.salvageCarAuctionRecords.length > 0;

    const sections: ReportSection[] = [
        { id: "passport", label: "Данные из ПТС", status: "ok" },
        { id: "accidents", label: "Участие в ДТП", status: hasCrashes ? "warning" : "ok" },
        { id: "owners", label: "Владельцы по ПТС", status: "ok" },
        { id: "tech", label: "Данные о техосмотрах", status: "ok" },
        { id: "legal", label: "Юридическая чистота", status: isLegalClear ? "ok" : "warning" },
        {
            id: "repair",
            label: "Расчёт стоимости ремонта",
            status: hasRepair ? "warning" : "ok"
        },
        {
            id: "commercial",
            label: "Коммерческое использование",
            status: isCommercialClear ? "ok" : "warning"
        },
        {
            id: "insurancePayments",
            label: "Страховые выплаты",
            status: isPaymentsClear ? "ok" : "warning"
        },
        { id: "fines", label: "Штрафы", status: hasFines ? "warning" : "ok" },
        {
            id: "auctions",
            label: "Аукционы битых автомобилей",
            status: hasAuction ? "warning" : "ok"
        },
        { id: "services", label: "Визиты в автосервис", status: "ok" },
        { id: "insurance", label: "Страховые полисы", status: "ok" },
        { id: "operations", label: "История эксплуатации", status: "ok" }
    ];

    return sections;
};